import {ErrorManager} from "./field-error";
import {F_ERR_ENUM} from "../enum/field-error.enum";

export default function parseApiError (error) {
  if (error.type === 'scalar_input_error') {
    return ErrorManager.factory(F_ERR_ENUM.API, 'remote_error_' + error.error.field);
  }
  if (error.type === 'RecordNotFoundException') {
    return ErrorManager.factory(F_ERR_ENUM.API, 'remote_record_not_found');
  }
  if (error.error_code === 'password_error') {
    return ErrorManager.factory(F_ERR_ENUM.API, 'password_error');
  }
  return error;
}



// WEBPACK FOOTER //
// ./src/helpers/api-error-parser.js